export const mockNotifications = [
  {
    id: "n1",
    type: "transaction",
    title: "Buy Order Completed",
    message: "You successfully bought 0.00124 BTC for ₦250,000. The crypto has been added to your wallet.",
    time: "2026-04-09T08:15:00Z",
    read: false,
    icon: "ri-arrow-down-circle-fill",
    iconColor: "#059669",
    iconBg: "#ECFDF5",
  },
  {
    id: "n2",
    type: "transaction",
    title: "Naira Withdrawal Successful",
    message: "₦180,000 has been sent to your GTBank account ending in 4521. It may take up to 24 hours to reflect.",
    time: "2026-04-09T07:02:00Z",
    read: false,
    icon: "ri-bank-fill",
    iconColor: "#059669",
    iconBg: "#ECFDF5",
  },
  {
    id: "n3",
    type: "alert",
    title: "Price Alert: ETH +8.4%",
    message: "Ethereum has surged 8.4% in the last 24 hours. Current price: ₦5,820,000. Tap to trade now.",
    time: "2026-04-09T06:30:00Z",
    read: false,
    icon: "ri-line-chart-fill",
    iconColor: "#D97706",
    iconBg: "#FFFBEB",
  },
  {
    id: "n4",
    type: "security",
    title: "New Login Detected",
    message: "A new login was detected on your account from Lagos, Nigeria. If this wasn't you, please secure your account immediately.",
    time: "2026-04-08T22:10:00Z",
    read: true,
    icon: "ri-shield-check-fill",
    iconColor: "#DC2626",
    iconBg: "#FEF2F2",
  },
  {
    id: "n5",
    type: "transaction",
    title: "Crypto Deposit Confirmed",
    message: "Your deposit of 0.5 ETH has been confirmed on the blockchain (3 confirmations). Funds are now available.",
    time: "2026-04-08T18:45:00Z",
    read: true,
    icon: "ri-arrow-down-circle-fill",
    iconColor: "#059669",
    iconBg: "#ECFDF5",
  },
  {
    id: "n6",
    type: "promo",
    title: "Zero Fees This Weekend!",
    message: "Trade crypto with 0% fees from Friday to Sunday. Limited time offer — buy, sell, or swap with no charges.",
    time: "2026-04-08T10:00:00Z",
    read: true,
    icon: "ri-gift-fill",
    iconColor: "#7C3AED",
    iconBg: "#F5F3FF",
  },
  {
    id: "n7",
    type: "kyc",
    title: "KYC Verification Approved",
    message: "Your identity verification has been approved. You now have access to higher transaction limits.",
    time: "2026-04-07T14:20:00Z",
    read: true,
    icon: "ri-verified-badge-fill",
    iconColor: "#059669",
    iconBg: "#ECFDF5",
  },
  {
    id: "n8",
    type: "alert",
    title: "Price Alert: BTC -5.2%",
    message: "Bitcoin has dropped 5.2% in the last 24 hours. Current price: ₦198,400,000. Consider buying the dip.",
    time: "2026-04-07T09:00:00Z",
    read: true,
    icon: "ri-line-chart-fill",
    iconColor: "#DC2626",
    iconBg: "#FEF2F2",
  },
];
